import { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'

import { AnalyticsContext } from '@elparking/analytics'
import { trackTealiumEvent } from 'commons/js/services/analytics'
 import { getCustomAnalyticEvents } from './Analytics.helper'

const Analytics = ({initAnalytics}) => {
    const { setService } = useContext(AnalyticsContext)

    useEffect(() => {
     initAnalytics(() => {
        setService(window.utag)
      })
      const ev = getCustomAnalyticEvents()

      trackTealiumEvent(ev)
    }, [setService, initAnalytics])
    return null
  }

  Analytics.propTypes = {
    initAnalytics: PropTypes.func,
  }

  Analytics.defaultProps = {
    initAnalytics: () => {},
  }

export default Analytics
